const momentDateFormat = "YYYY-MM-DD",
  slashedDateFormat = "YYYY/MM/DD",
  momentDateTimeFormat = "YYYY-MM-DD HH:mm:ss",
  slashedDateTimeFormat = "YYYY/MM/DD HH:mm:ss",
  slashedDateTimeFormatDateFNS = "yyyy/MM/dd HH:mm:ss";

const dataTypeKeys = {
  POSTING: "posting",
  ORIKOMI: "orikomi",
};

const paymentMethod = (text) => {
  if (text == "credit") {
    return "クレジットカード";
  } else if (text == "pay_easy") {
    return "ペイジー";
  } else if (text == "invoice") {
    return "請求書払い";
  } else if (text == "cvs") {
    return "コンビニ";
  } else if (text == "points") {
    return "ポイント払い";
  }
};

export {
  momentDateFormat,
  slashedDateFormat,
  momentDateTimeFormat,
  slashedDateTimeFormat,
  paymentMethod,
};
